module.exports = __webpack_public_path__ + "img/houses_thumb.f9082209.jpg";